import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const DealerGraph = ({ chartData, dealerTierName = '' }) => {
  const fallbackData = [
    { label: 'MAR 25', value: 30 },
    { label: 'FEB 25', value: 42 },
    { label: 'JAN 25', value: 183 },
    { label: 'DEC 24', value: 230 },
    { label: 'NOV 24', value: 250 },
    { label: 'OCT 24', value: 284 },
  ];
  

//   const finalData = chartData.length > 0 ? chartData : fallbackData;
  const finalData = chartData;

  const labels = finalData.map(item => item.label);
  const values = finalData.map(item => item.value);

  const backgroundColors = finalData.map((_, i) =>
    i % 2 === 0 ? '#7F57DB' : '#EC4A8D' 
  );

  const data = {
    labels,
    datasets: [
      {
        label: 'Volume in (MT)',
        data: values,
        backgroundColor: backgroundColors,
        borderRadius: 5,
        barThickness: 18,
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        display: true,
        color: '#000',
        align: 'end',
        anchor: 'end',
        formatter: value => value,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Volume in (MT)',
          font: {
            size: 12,
          },
        },
        grid: {
          display: true,
          color: '#eee',
        },
        ticks: {
        //   precision: 0,
        //   stepSize: 50,
        display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 12,
            weight: '500',
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', padding: '1rem' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default DealerGraph;

